// extracted by mini-css-extract-plugin
var _1 = "NMAV00QqfK M3_uvSqMlP";
var _2 = "E39sOZuUMC";
var _3 = "qEpmB6pgsO";
export { _1 as "award", _2 as "icon", _3 as "message" }
